import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";
import { ReactElement } from "react";

import { SelectOption } from "../constants";

interface FormSelectFieldProps {
  label: string;
  value: string;
  options: SelectOption[];
  error?: string;
  onChange: (value: string) => void;
}

const FormSelectField = ({
  label,
  value,
  options,
  error,
  onChange
}: FormSelectFieldProps): ReactElement => (
  <FormControl fullWidth error={!!error} required>
    <InputLabel>{label}</InputLabel>
    <Select value={value} label={label} onChange={(e): void => onChange(e.target.value)}>
      {options.map((opt) => (
        <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
      ))}
    </Select>
    {error && <FormHelperText>{error}</FormHelperText>}
  </FormControl>
);

export default FormSelectField;
